module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg2IiBoZWlnaHQ9IjYyIiB2aWV3Qm94PSIwIDAgMTg2IDYyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIG9wYWNpdHk9Ii45Ij48Y2lyY2xlIG9wYWNpdHk9Ii40IiBjeD0iMTI3IiBjeT0iMTAiIHI9IjE2NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMTE0KSIgc3Ryb2tlPSIjMDA4NEZGIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1vcGFjaXR5PSIuMyIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/service-bg-1.svg
// module id = 83
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512